import { render, staticRenderFns } from "./template-variables-help.vue?vue&type=template&id=f32c51a0&scoped=true&"
import script from "./template-variables-help.vue?vue&type=script&lang=ts&"
export * from "./template-variables-help.vue?vue&type=script&lang=ts&"
import style0 from "./template-variables-help.vue?vue&type=style&index=0&id=f32c51a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32c51a0",
  null
  
)

export default component.exports